import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import NewReferralOrder from './NewReferralOrder'

import ReferralOrdersList from './ReferralOrdersList'

export default function ReferralOrders() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/referral_orders" component={ReferralOrdersList} />
				<Route exact path="/referral_orders/new" component={NewReferralOrder} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}